import type { BulkAction } from "@/components/shared/UniversalCRMTable/types";
import { ENHANCED_CONTACT_DETAIL_CONFIG } from "../components/ContactDetailConfig";

// Actions and bulk actions configuration
export const contactActions = {
  view: true,
  edit: true,
  delete: true,
};

export const contactDetailActions = ENHANCED_CONTACT_DETAIL_CONFIG.actions;

export const contactBulkActions: BulkAction[] = [
  {
    id: "bulk_export_emails",
    label: "Export Emails",
    icon: "mail",
  },
  {
    id: "bulk_update_status",
    label: "Update Status",
    icon: "check",
  },
  {
    id: "bulk_update_type",
    label: "Update Type",
    icon: "tag",
  },
];
